<template>
	<BaseLink :link="updateLink" class="col">
		<div class="asset-details-update-card dark">
			<div class="rounded-top">
				<img class="rounded-top" :src="thumbnail" alt="" role="presentation" />
			</div>
			<div class="px-100 py-50 display-flex flex-direction-column flex-grow-1">
				<h4 class="body-lg font-weight-bold my-25 line-clamp">{{ title }}</h4>
				<p class="body-sm mt-50 mb-100 line-clamp">{{ subtitle }}</p>
				<span class="body-md font-weight-bold text-color-rust text-align-right mt-auto mb-25">View update</span>
			</div>
		</div>
	</BaseLink>
</template>
<script setup lang="ts">
import { AssetUpdateSanity } from 'types/assets';
import { computed } from 'vue';
import { Link } from 'types/layout';

interface Props {
	update: AssetUpdateSanity;
}

const props = defineProps<Props>();

const updateLink: Link = {
	router: 'investor-update',
	params: {
		investorUpdateId: props.update.fundriseId
	}
};

const thumbnail = computed((): string => props.update.thumbnailUrl);

const title = computed((): string => props.update.title);

const subtitle = computed((): string => props.update.subtitle);
</script>
<style lang="scss" scoped>
@use '../../../styles/constants/colors.scss' as *;
@use '../../../styles/utilities/respond-to.scss' as *;

.asset-details-update-card {
	display: flex;
	flex-direction: column;
	height: 100%;
	background: #fff;
	border-radius: 8px;
	border: 1px solid token('bg-tertiary');
	@include respond-to(md) {
		width: 343px;
	}

	img {
		opacity: 1;
		object-fit: cover;
		max-height: 192px;
	}
}

.line-clamp {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}

.rounded-top {
	border-radius: 8px 8px 0 0;
}
</style>
